import * as S from './InlineStringEditor.styles';
import * as QueryEditorStyles from './QueryEditor.styles';

import React from 'react';
import WBSuggester, {WBSuggesterOptionFetcher} from '../elements/WBSuggester';
import {WBMenuOption} from '../elements/WBMenu';
import makeComp from '../../util/profiler';

interface InlineStringEditorProps {
  value: string;
  disabled?: boolean;
  autocompleteOptions?: WBMenuOption[] | WBSuggesterOptionFetcher;
  setValue(val: string): void;
}

const InlineStringEditor: React.FC<InlineStringEditorProps> = makeComp(
  props => {
    const ref = React.useRef<HTMLSpanElement>(null);
    const [autocompleterQuery, setAutocompleterQuery] = React.useState('');
    const [autocompleterOpen, setAutocompleterOpen] = React.useState(false);
    React.useEffect(() => {
      if (props.value === '' && document.querySelector(':focus') == null) {
        ref.current?.focus();
      }
    }, [props.value]);
    return (
      <>
        <span style={{pointerEvents: 'none'}}>"</span>
        <QueryEditorStyles.ArgSpan spellCheck="false">
          <WBSuggester
            options={props.autocompleteOptions}
            onSelect={v => {
              setAutocompleterOpen(false);
              props.setValue(v as string);
            }}
            query={autocompleterQuery}
            open={autocompleterOpen}
            onParentScroll={() => setAutocompleterOpen(false)}>
            {({inputRef}) => (
              <S.InlineContentEditable
                innerRef={node => {
                  (ref as any).current = node;
                  inputRef(node);
                }}
                value={props.value}
                disabled={props.disabled}
                onFocus={() => {
                  setAutocompleterOpen(true);
                  setAutocompleterQuery(props.value);
                }}
                onBlur={() => setAutocompleterOpen(false)}
                onTempChange={v => {
                  setAutocompleterQuery(v);
                  setAutocompleterOpen(true);
                }}
                onChange={v => {
                  props.setValue(v);
                }}></S.InlineContentEditable>
            )}
          </WBSuggester>
        </QueryEditorStyles.ArgSpan>
        <span style={{pointerEvents: 'none'}}>"</span>
      </>
    );
  },
  {id: 'InlineStringEditor'}
);

export default InlineStringEditor;
